import type { HydraErrorType } from '@/lib/services/Hydra/_hydraError'
import React from 'react'
import T from '@/components/Helpers/Translate'
import { Alert, AlertDescription, AlertTitle } from '../Alert'

type Props = {
  error: HydraErrorType | null
}

export const ErrorAlert = ({ error }: Props) => {
  if (!error) return null

  return (
    <Alert variant="destructive" className="my-3">
      <AlertTitle>
        <T>error</T>
      </AlertTitle>
      <AlertDescription className="text-sm break-words md:text-base">
        {`${error.error?.code ?? ''} ${error.error?.code ? ': ' : ''} ${
          error?.error?.message ?? ''
        }`}
        {error?.error?.error_message && <p>{error?.error?.error_message}</p>}
      </AlertDescription>
    </Alert>
  )
}
